import { EmptyTalkerPropsFactory, ITalkerProps } from '@/entities/Talker'
import { EmptyQueryPropsFactory, IQueryProps } from '@/entities/Query'

export interface ITalkerState {
  byIds: {
    [id: string]: ITalkerProps
  }
  fetched: ITalkerProps[]
  query: IQueryProps
  loading: boolean
  current: ITalkerProps
  reset: boolean
}

export const state = (): ITalkerState => ({
  byIds: {},
  fetched: [],
  query: EmptyQueryPropsFactory(),
  loading: false,
  current: EmptyTalkerPropsFactory(),
  reset: true
})

export default state
